module.exports = "/lucky-balls/img/bonus_yellow/hole.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/hole.png
// module id = 973
// module chunks = 0